/**
 * "How it works" on the public site (doc 3 B3, B5; Anthony's package, 2026-10-28): opens
 * "How Fomo-Fi works" at step 1 over the current marketing page. Used by the top nav, its
 * phone drawer and the splash hero.
 */
import { useLocation } from "react-router-dom";
import { WALKTHROUGH_SPLASH_PAGE_COPY } from "@fomofi/shared";
import { useWalkthrough } from "@/hooks/use-walkthrough";
import { marketingPageName } from "@/lib/marketingNav";

export function HowItWorksButton({
  className,
  children,
  onOpen,
}: {
  className?: string;
  children: React.ReactNode;
  /** Runs before the walkthrough opens, e.g. to close the drawer it sits in. */
  onOpen?: () => void;
}) {
  const { openWalkthrough } = useWalkthrough();
  const { pathname } = useLocation();
  return (
    <button
      type="button"
      className={className}
      onClick={() => {
        onOpen?.();
        // "Opens the walkthrough at step 1" (B3, B5): a saved step doesn't move it.
        openWalkthrough({
          step: 1,
          deepLink: true,
          from: marketingPageName(pathname, WALKTHROUGH_SPLASH_PAGE_COPY),
        });
      }}
    >
      {children}
    </button>
  );
}
